export default "__VITE_ASSET__CemwtsNp__"